<template>
    <BentoFrame
        class="bento-hero"
        dark
    >
        <template
            v-if="$slots.image"
            #image
        >
            <slot name="image" />
        </template>
        <h1
            v-if="title"
            class="bento-hero__title"
        >
            {{ title }}
        </h1>
        <p
            v-if="description"
            class="bento-hero__description"
        >
            {{ description }}
        </p>
    </BentoFrame>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: null
    },
    description: {
        type: String,
        default: null
    }
});
</script>

<style lang="less" src="./BentoHero.less" />
